<template>
  <div>
    <div class="test-container">
    <div class="test-bg" v-if="!showList.length">
      <img src="../images/no_data.png" alt="">
      <span> 暂无数据～</span>
    </div>
    <div class="test-item" v-else v-for="(item,index) in showList" :key="index">
      <div class="test-title">
        <div class="test-subject math" v-if="item.subject_id===2">
         数</div>
            <div class="test-subject physics" v-else-if="item.subject_id===1">
         英</div>
          <div class="test-subject math" v-else-if="item.subject_id===3">
         语</div>
           <div class="test-subject chemistry"
           v-else-if="item.subject_id===900||item.subject_id===5">
         化</div>
          <div class="test-subject physics" v-else-if="item.subject_id===4">
         物</div>
        <div class="test-section">{{item.evaluate_name}}</div>
      </div>
      <div class="test-foot">
        <div class="test-time">
          <span>发布时间 {{item.created}}</span>
        </div>
        <button class="test-button" @click="getTaskTokenInfo(item)">立即测试</button>
      </div>
    </div>
  </div>
  <div class="prepare-pagination" v-if="showList.length">
      <el-pagination
       background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
      </el-pagination>
  </div>
  </div>
</template>

<script>
/* eslint-disable */
import { getSign } from '@/pages/uc-web/utils/verify'
import api from '@/pages/uc-web/api/api'
import moment from 'moment';
import { openTab } from '@/utils';

export default {
  name:'UnfinishedList',
  data() {
    return {
      params: {},
    };
  },
  props: {
    activeId: {
      default: '0',
      type: String,
    },
    unfinishedList: {
      type: Array,
      default: () => [],
    },
    pageSize: {
      default: 10,
      type: Number,
    },
    total: {
      default: 0,
      type: Number,
    },
  },
  computed: {
    showList() {
      if (this.activeId === '0') {
        return this.unfinishedList;
      }
      return this.unfinishedList.filter((item) => item.subject_id.toString() === this.activeId);
    },
  },
  filters: {
    formatTime(val) {
      return moment(val).format('MM-DD HH:mm')
    },
  },
  methods: {
    async getTaskTokenInfo(item){
      const params = {
        // school_id:2217	,
        school_id:localStorage.getItem('school_id'),
        // account_id:8885623813293003,
        account_id:localStorage.getItem('account_id'),

        evaluate_id:item.evaluate_id,
        type:1
      }

      const res = await api.getStuTaskTokenInfo(params)
      console.log(res.data);
      if(res.code===200){
        const tokenParams = {token:res.data}
        tokenParams.sign = getSign(tokenParams);
        const data = await api.tokenLogin(tokenParams)
        console.log(data);
        const{tsid}=data.data;
        const{course_type}=data.data;
        const{yx_token} = data.data;
        const{real_name} = data.data.user_info;
        const source_type = localStorage.getItem('source_type') || 0;
        const isProduction = !window.location.host.includes('test');
        const schoolId = localStorage.getItem('school_id') || '';
      // 区分线上和测试环境
      // const host = isProduction
      //    ? 'https://jzjx.classba.cn'
      //   : 'https://jzjx-test.classba.cn'; // 测试环境
      const host = `${window.location.protocol}//${window.location.host}`
      //  const host = 'https://jzjx-test.classba.cn'; // 开发环境
        const url =  `${host}/dl-web/do/question?id=${tsid}&courseType=${course_type}&token=${yx_token}&userName=${real_name}&sourceType=${source_type}&schoolId=${schoolId}`
          openTab(url)
      }else{
        this.$toast(res.msg)
      }

    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      // this.pageSize = val;
      this.$emit('changePageSize', val);
      // localStorage.setItem('pageSize', val);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      // this.currentPage = val;
      this.$emit('changeCurrent', val);
      localStorage.setItem('currentPage', val);
    },
  },
};
</script>

<style lang="scss" scoped>
.test-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  font-family: PingFangSC-Medium, PingFang SC;
  .test-bg{
    margin: 86px auto;
    position: relative;
    img{
      display: block;
    }
    span{
      position: absolute;
      left: 50%;
      transform: translate(-50%,12px);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(17, 31, 44, 0.6);
    }
  }
  .test-item {
    box-sizing: border-box;
    width: 492px;
    height: 125px;
    background: url("../images/test-bg.png") no-repeat;
    padding: 25px;
    margin-bottom: 18px;
    .test-title {
      font-size: 14px;
      font-weight: 550;
      display: flex;
      margin-bottom: 18px;
      .test-subject {
        width: 24px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        background: #0dd4c8;
        border-radius: 6px;
        margin-right: 8px;
        color:#FFFFFF
      }
      .test-section {
        width: 340px;
        height: 22px;
        font-size: 16px;
        font-weight: 500;
        color: #111f2c;
        line-height: 22px;
        letter-spacing: 1px;
      }
      .math{
      background-color: #0DD4C8;
      }
      .physics{
        background-color: #27ACFF;
      }
      .chemistry{
        background-color: #9962F8;
      }

    }
    .test-foot {
        display: flex;
        justify-content: space-between;
          font-size: 14px;
        .test-time {
          // font-weight: 400;
          color: rgba(17, 31, 44, 0.6);
          line-height: 20px;
          margin-top:8px ;
        }
        .test-button {
          font-weight: 500;
          color: #FFFFFF;
          width: 100px;
          height: 30px;
          background: #2194FF;
          box-shadow: 0px 3px 5px 0px rgba(33, 148, 255, 0.4);
          border-radius: 16px;
          margin-right: 2px;
          cursor: pointer;
        }
      }
  }
}
.prepare-pagination{
  height: 103px;
  display: flex;
  align-items: center;
}
/deep/.el-table{
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #606266;
    .el-table__header th {
    background-color: #F0F2F5;;
    }
  }
  /deep/ .el-pagination {
    display: flex;
    // position: absolute;
    width: calc(100% - 64px);
    // bottom: 30px;
    // left: 32px;
    .btn-prev {
      margin-left: auto !important;
    }
  }

@media screen and (max-width:1200px) {
  .test-container .test-item {
    width: 390px;
    background-size: 100% 100%;
  }
}
</style>
